// extracted by mini-css-extract-plugin
module.exports = {"full":"section_full__07XLc","contained":"section_contained__iF_Sa"};